import React, { useMemo} from 'react';
import Element from '@/features/cms/components/Element';
import Portal from './Portal';

const DropdownRoot = (props) => {
  const elements = useMemo(() => {
    return JSON.parse(props.elements);
  }, [props.elements]);

  return (<>
      {elements.map((e, i) =>
          <Element key={i} {...e} navCenterItemsClasses={props.navCenterItemsClasses}/>)}
  </>);
};

export default () => {
    return <Portal selector='#DropdownRoot'>
        {(dataset) => React.createElement(DropdownRoot, dataset)}
    </Portal>
};